import { cn } from '@/utils/cn';
import { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  suffix?: string;
}

/**
 * Input component
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, suffix, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-ink/80 mb-1">
            {label}
          </label>
        )}
        <div className="relative">
          <input
            ref={ref}
            className={cn(
              'w-full px-3 py-2 border border-ink/15 rounded-lg',
              'focus:outline-none focus:ring-2 focus:ring-ink focus:border-transparent',
              'disabled:bg-monta-gray-100 disabled:cursor-not-allowed',
              'placeholder:text-monta-gray-400',
              error && 'border-monta-red focus:ring-monta-red',
              suffix && 'pr-12',
              className
            )}
            {...props}
          />
          {suffix && (
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <span className="text-sm text-muted">{suffix}</span>
            </div>
          )}
        </div>
        {error && <p className="mt-1 text-sm text-monta-red">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
